import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue' 
import vuetify from './plugins/vuetify'
import store from './store'
import VueLogger from 'vuejs-logger'; 
import VueI18n from 'vue-i18n'
import getBrowserLocale from "@/components/util/get-browser-locale"
import { v4 as uuidv4 } from 'uuid';
import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import VueWebSpeech from 'vue-web-speech'

Vue.config.productionTip = false

//const debug = process.env.NODE_ENV !== 'production'
 
// **********************************************************

Vue.use(VueI18n)
Vue.use(VueWebSpeech)

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  const supportedLocales = ["es", "en", "ro", "it", "pt"];
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locale",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

// **********************************************************


const isProduction = process.env.NODE_ENV === 'production';

// **************************************************

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  //iconsGroup: 'md'
})
// **********************************************************

const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(require('vue-moment'));

Vue.use(VueGoogleMap, {
  load: {
      apiKey: 'AIzaSyC5MifXnsUxeSBYtxX1HUV1QCUFoOtC9H4',
      libraries: ['places']
  }
})

// ***********************************************************

// @hack: Make sure we don't re-use the page's current style element
vuetify.framework.theme.checkOrCreateStyleElement = function () {
  if (!this.styleEl) this.genStyleElement()
  return Boolean(this.styleEl)
}

let treeHead = document.querySelector(".vue-wrapper-container");
let parent   = document.createElement("div");
let holder   = document.createElement("div");
let shadow   = treeHead.attachShadow({mode: 'closed'});



// Monkey patch querySelector to properly find root element
const { querySelector } = document
document.querySelector = function (selector) {
  if (selector === '[data-app]') {
        if (shadow.querySelector('[data-app]'))
            return shadow.querySelector('[data-app]');
        else
            return shadow
  } 
  return querySelector.call(this, selector)
}

 
var link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css?family=Material+Icons';
    shadow.appendChild(link);

link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css';
    shadow.appendChild(link);


/*

    link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.core.min.css';
    shadow.appendChild(link);



  link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.bubble.min.css';
    shadow.appendChild(link);

    link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.min.css';
    shadow.appendChild(link);

*/

link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.cdnfonts.com/css/google-sans';
    shadow.appendChild(link);
 
link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://cdn.form.io/formiojs/formio.full.min.css';
    shadow.appendChild(link);

link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    //link.href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css';
    link.href = 'css/formio.css';
    shadow.appendChild(link);

    link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';
    shadow.appendChild(link);

link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'css/worktime-vue.css?v=3.4';
    shadow.appendChild(link);
 
link  = document.createElement('link');
    //link.id   = cssId;
    link.rel  = 'stylesheet';
    link.href = 'css/tiptap.css';
    shadow.appendChild(link);
    
window.$vueWrapperParent=parent;

shadow.appendChild(holder);



  const vue =
      new Vue({ 
        el: holder,
        vuetify,
        store,
        i18n,
        render: h => {
            let vuetifyStyle = document.getElementById('vuetify-theme-stylesheet');
            shadow.appendChild(vuetifyStyle);

            setTimeout (fixHeadStyles,1500);

            return  h(App, {}); 
        }
      });//.$mount('#app');

  window.$vue = vue;
  window.$vueWrapper = treeHead;
  window.$vueWrapper.style.display = 'none';

//FIXME: tiene que ser dinámico
//window.$vue.$vuetify.lang.current = 'es'; 

window.$store = store;
window.$i18n = i18n;


// **********************************************************

if (!window.localStorage.getItem("worktime-device-uuid"))
    window.localStorage.setItem("worktime-device-uuid",uuidv4().toString().toUpperCase().substring(4,18));

window.$store.commit('worktime/setUuid', window.localStorage.getItem("worktime-device-uuid"));


function fixHeadStyles() {
    fixStyle('vuetify');
}

function fixStyle(style) {
    let styles = document.getElementsByTagName('style');
    for (var i=styles.length-1; i>=0;i--)
    {
        if (styles[i].innerText.indexOf(style)>=0) {
            shadow.appendChild(styles[i]);
        }
    }
}
